/*global TweenMax b:true*/
/*global TweenMax b:TimelineMax*/
/*global TweenMax b:TweenLite*/
/*global TweenMax b:CustomEase*/
/*global TweenMax b:SplitText*/
/*eslint no-undef: "error"*/
/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function () {
jQuery(document).foundation();

  // // Remove empty P tags created by WP inside of Accordion and Orbit
  // jQuery('.accordion p:empty, .orbit p:empty').remove();
  
  // Adds Flex Video to YouTube and Vimeo Embeds
  jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function () {
    if (jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5) {
      jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
    } else {
      jQuery(this).wrap("<div class='responsive-embed'/>");
    }
  });
  
  
  // Path: core/themes/dmcpas_master/assets/scripts/js/wp-foundation.js
  
  var line1 = jQuery('.banner-content-copy-wrapper .line1');
  if(line1.length > 0) {
    var line2 = jQuery('.banner-content-copy-wrapper .line2');
    var line3 = jQuery('.banner-content-copy-wrapper .line3');
    var line4 = jQuery('.banner-content-copy-wrapper .line4');
    var line4Start = jQuery('.banner-content-copy-wrapper .line4-start');
    var line5 = jQuery('.banner-content-copy-wrapper .line5');
    var line6 = jQuery('.banner-content-copy-wrapper .line6');
    var buttonIcon = jQuery('.banner-content-copy-wrapper .button-icon');
    var tl = gsap.timeline();
    gsap.to('.banner-content-copy-wrapper .line1', {
      duration: 1,
      translateX: 400,
      opacity: 1,
      delay: 1,
    });
    gsap.to('.banner-content-copy-wrapper .line2', {
      duration: 1,
      translateX: 400,
      translateY: 9,
      opacity: 1,
      delay: 2,
    });
    gsap.to('.banner-content-copy-wrapper .line3', {
      duration: 1,
      translateX: 400,
      opacity: 1,
      delay: 3,
    });
    gsap.to('.banner-content-copy-wrapper .line1', {
      duration: 1,
      translateY: 800,
      opacity: 1,
      delay: 4,
    });
    gsap.to('.banner-content-copy-wrapper .line2', {
      duration: 1,
      translateY: 800,
      opacity: 0,
      delay: 5,
    });
    gsap.to('.banner-content-copy-wrapper .line3', {
      duration: 1,
      translateY: 800,
      opacity: 0,
      delay: 6,
    });
    gsap.to('.banner-content-copy-wrapper .line4-start', {
      duration: 2,
      opacity: 1,
      delay: 6,
    });
    gsap.to('.banner-content-copy-wrapper .animation-div.line4', {
      duration: 2,
      opacity: 1,
      delay: 6,
    });
    // gsap.to('.banner-content-copy-wrapper .line4-start', {duration: 2, text: {value: "This is the new text", delimiter: " "}, ease: "none"});
    //a DOM element:
    var yourElement = document.getElementsByClassName("line5");
    var split = new SplitText(yourElement);
    gsap.to(split.words, {duration: 1, opacity: 0, stagger: .3, delay: 9, translateX: -400});
    gsap.to('.banner-content-copy-wrapper .line6', {
      duration: 2,
      opacity: 1,
      delay: 10,
    });
    gsap.to('.banner-content-copy-wrapper .line5', {
      duration: 1,
      opacity: 0,
      delay: 11,
    });
    gsap.to('.animation-div.button-icon', {
      duration: 1,
      opacity: 1,
      delay: 11,
    });
  }
});